import { render, staticRenderFns } from "./ResearchCredibleSets.vue?vue&type=template&id=420de098"
import script from "./ResearchCredibleSets.vue?vue&type=script&lang=js"
export * from "./ResearchCredibleSets.vue?vue&type=script&lang=js"
import style0 from "./ResearchCredibleSets.vue?vue&type=style&index=0&id=420de098&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ec2-user/.jenkins/workspace/CFDE Knowledge - Dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('420de098')) {
      api.createRecord('420de098', component.options)
    } else {
      api.reload('420de098', component.options)
    }
    module.hot.accept("./ResearchCredibleSets.vue?vue&type=template&id=420de098", function () {
      api.rerender('420de098', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/researchPortal/ResearchCredibleSets.vue"
export default component.exports